import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import Input, { InputProps } from "../input";
import { useControlGroupSize } from "./context";
import { controlGroupControlStyles } from "./styles";

const ControlGroupInput = forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  InputProps
>(({ className, size, ...props }, ref) => {
  const resolvedSize = useControlGroupSize(size);

  return (
    <Input
      {...props}
      ref={ref}
      size={resolvedSize}
      className={twMerge(controlGroupControlStyles, className)}
    />
  );
});

export default ControlGroupInput;
